import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { fetchConfig } from "api/config";
import SegmentRecordSection from "./SegmentRecordSection";
import { fetchTestRecordings } from "api/testing";
import { useIntl } from "react-intl";
import { isTestingMode } from "components/TestingMode";
const SegmentRecordSubpage = ({ eventId }) => {
    const intl = useIntl();
    const [config, setConfig] = useState('loading');
    const [testRecordings, setTestRecordings] = useState('loading');
    useEffect(() => {
        const fetchConfigState = async () => {
            setConfig(await fetchConfig());
        };
        const loadTestRecordings = async () => {
            setTestRecordings(await fetchTestRecordings());
        };
        void loadTestRecordings();
        void fetchConfigState();
    }, []);
    if (config === 'loading' ||
        testRecordings === 'loading') {
        return _jsx("p", { children: intl.formatMessage({ id: 'loading' }) });
    }
    if (isTestingMode() && testRecordings.isFail()) {
        let errorMessage = '';
        switch (testRecordings.err()) {
            case 'NO_INDEX_FILE':
                errorMessage = intl.formatMessage({ id: 'noIndexFile' });
                break;
            case 'INVALID_INDEX_FILE':
                errorMessage = intl.formatMessage({ id: 'invalidIndexFile' });
                break;
            case 'UNKNOWN_ERROR':
                errorMessage = intl.formatMessage({ id: 'unknownRecordingsError' });
                break;
        }
        return (_jsxs("div", { children: [_jsx("p", { children: errorMessage }), _jsx("p", { children: intl.formatMessage({ id: 'fixTestRecordings' }) })] }));
    }
    return (_jsx(SegmentRecordSection, { eventId: eventId, config: config, testRecordings: testRecordings.isSuccess() ? testRecordings.get() : [] }));
};
export default SegmentRecordSubpage;
